import React, { Component } from 'react';
import styles from './index.css';
import {observer} from 'mobx-react'
import {presets} from '../../../stores/index';
import regionData from '../../../stores/presets/regionData.json';

@observer
export default class ChooseRegion extends Component {
    state={selected:(presets.region ? presets.region.item : -1),over:-1};

    render() {
        return (
            <div className={styles.chooseRegion}>
                <h3>ОБЕРІТЬ РЕГІОН РОЗМІЩЕННЯ</h3>
                <div className={styles.regionsList}>
                    <ul>
                        {regionData.map((item,i)=>{
                            if(item.disabled){
                                return null;
                            }
                            return <li
                                className={(this.state.selected === i ? ' ' + styles.chosen : (this.state.over === i  ?  ' ' + styles.over  :  ''))}
                                key={i}
                                onMouseOver={()=>{this.setState({over:i})}}
                                onMouseLeave={()=>{this.setState({over:-1})}}
                                onClick={()=>{this.setState({selected:i});presets.setRegion({name:regionData[i].name, item:i},regionData[i].cultures);presets.setCulturePlan()}}
                            >{item.name}</li>
                        })}
                    </ul>
                </div>
                <div className={styles.regionsMap}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 724 490" preserveAspectRatio="xMidYMid meet">
                        {regionData.map((item,i)=>{

                            if(item.disabled){
                                return  <polygon
                                    key={i}
                                    className={styles.chosenRegion + ' ' + styles.disabledRegion}
                                    points={item.points}
                                />
                            }
                            return(

                                <polygon
                                    key={i}
                                    onMouseOver={()=>{this.setState({over:i})}}
                                    onMouseLeave={()=>{this.setState({over:-1})}}
                                    onClick={()=>{this.setState({selected:i});presets.setRegion({name:regionData[i].name, item:i},regionData[i].cultures);presets.setCulturePlan()}}
                                    className={styles.chosenRegion + (this.state.selected === i ? ' ' + styles.chosen : (this.state.over === i  ?  ' ' + styles.mapOver  :  ''))}
                                    points={item.points}
                                />
                            )
                        })}

                    </svg>
                </div>
                {/*<div className={styles.button + ' ' + styles.mapButton + (this.state.selected !== -1 ? '': ' ' + styles.disabled)}>выбрать</div>*/}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/EquipComponents/ChooseRegion/index.js